import { Box, Typography } from '@mui/material';
import { MessageView } from 'components/ui/Feedback';
import React from 'react';

import { baseUrls } from '../../../utils/baseUrls.utils';
import { topicsOrCategories } from '../../../utils/utils';

import { useHistory } from 'react-router-dom';

interface NoArticlesPlaceholderProps {
    isChannel?: boolean;
}

export const NoArticlesPlaceholder: React.FC<NoArticlesPlaceholderProps> = ({
    isChannel,
}) => {
    const { push } = useHistory();

    return (
        <Box sx={{ mx: 'auto', py: 6, backgroundColor: 'background.paper' }}>
            <MessageView
                styleName="primary"
                size="medium"
                title="No articles yet"
                primaryAction={{
                    label: `Browse ${isChannel ? 'Channels' : topicsOrCategories(true)}`,
                    onClick: () => {
                        push(baseUrls.channels.main);
                    },
                }}
            >
                <Typography
                    variant="body1"

                    sx={{
                        color: 'text.secondary',
                    }}
                >
                    This {isChannel ? 'Channel' : topicsOrCategories()} hasn’t
                    received contributions yet. You can search articles or
                    explore the available{' '}
                    {isChannel ? 'channels' : topicsOrCategories(true)}.
                </Typography>
            </MessageView>
        </Box>
    );
};

export default NoArticlesPlaceholder;
